
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { Roles } from "@/helpers/enums/Roles";

export default defineComponent({
  name: "Title",
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  data() {
    return {
      Roles: Roles,
    };
  },
});
